/***************************************************************
6/13/2017
Alexander Self
edit_work_table.js
- Table that maintains a list of work performed;
***************************************************************/
import React from 'react';

import { totalHours } from '../../../utils';

const EditWorkTable = ({ work, removeWork, editWork }) => {
  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr>
          <th>Grade</th>
          <th>Work</th>
          <th>Hours</th>
          <th>Cost Center</th>
          <th>Sub Account</th>
          <th>Equip No.</th>
          <th>Paycode</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          work.map((w, i) => (
            <tr key={w.id}>
              <td>{ w.tempGrade }</td>
              <td>{ w.workPerformed }</td>
              <td>{ w.hours }</td>
              <td>{ w.costCenterCode }</td>
              <td>{ w.subAccount }</td>
              <td>{ w.equipmentNo }</td>
              <td>{ w.paycode }</td>
              <td>
                <button onClick={() => editWork(w)} className="btn-floating waves-effect waves-light blue">
                  <i className="material-icons">mode_edit</i>
                </button>
              </td>
              <td>
                <button onClick={() => removeWork(w.id)} className="btn-floating waves-effect waves-light red">
                  <i className="material-icons">clear</i>
                </button>
              </td>
            </tr>
          ))
        }
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td><center>Total Hours</center></td>
          <td><b><center>{ totalHours(work) }</center></b></td>
        </tr>
      </tfoot>
    </table>
  )
};

export default EditWorkTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/edit/edit_work_table.js